
export const PATTERN_LINES_ID = 'pattern--lines';

const SIZE = 8;

export const PatternLines: React.FC = () => (
  <pattern
    id={PATTERN_LINES_ID}
    patternUnits="userSpaceOnUse"
    width={100}
    height={SIZE}
  >
    <rect width={100} height={SIZE / 2} opacity="0.2" />
  </pattern>
);
